import SignInEmail from '@/screens/SignInEmail';

export default function AuthSignInEmailRoute() {
  return <SignInEmail />;
}
